
import { Table } from 'reactstrap';
import { NoResult, Paging } from 'src/components/customcontrols';
import { DSLoadingPanel } from '@demandstar/components/loading-panel/DSLoadingPanel';

interface Supplier {
  name: string;
  city: string;
  state: string;
}

interface InstantBidSuppliersTableProps {
  suppliers: Supplier[];
  loading: boolean;
  currentPage: number;
  supplierPerPage: number;
  selectedCommodityIds: any[];
  onPageChange: (page: number) => void;
}

export function InstantBidSuppliersTable({
  suppliers,
  loading,
  currentPage,
  supplierPerPage,
  selectedCommodityIds,
  onPageChange,
}: InstantBidSuppliersTableProps) {
  if (!selectedCommodityIds.length) return null;

  const indexOfLast  = currentPage * supplierPerPage;
  const indexOfFirst = indexOfLast - supplierPerPage;

  return (
    <div>
      <h5>Suppliers {!loading ? `(${suppliers.length})` : ''}</h5>

      <Table className='tableHData'>
        <thead>
          <tr>
            <th>Supplier</th>
            <th>City, State</th>
          </tr>
        </thead>
        <tbody>
          {suppliers?.length > 0 && !loading ? (
            suppliers.slice(indexOfFirst, indexOfLast).map((supplier, index) => (
              <tr key={index}>
                <td>{supplier.name}</td>
                <td>
                  {supplier.city}
                  {supplier.city && supplier.state && ', '}
                  {supplier.state}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={2}>
                {loading ? (
                  <DSLoadingPanel>Loading Suppliers...</DSLoadingPanel>
                ) : (
                  <NoResult message='No Suppliers Available' />
                )}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {!loading && (
        <Paging
          totalRecords={suppliers.length}
          currentPage={currentPage}
          onPagingClick={(value: any) => {
            if (value !== currentPage) onPageChange(Number(value));
          }}
          limitmsg={false}
          pageLimit={supplierPerPage}
          allowScrollToTop={false}
        />
      )}
    </div>
  );
}
